import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_PATH, COSTS_API_PATH, COUNTRIES_API_PATH } from './constants';
import {
  DEFAULT_ALLOWED_ENTITIES_RESPONSE,
  DEFAULT_CONTRACT_OUSTANDING_FEES,
  DEFAULT_CONTRACT_UPDATE_RESPONSE,
  DEFAULT_CONTRACTOR,
  DEFAULT_CONTRACTOR_BANK_DETAILS,
  DEFAULT_CONTRACTOR_DOCUMENT_UPLOAD_RESPONSE,
  DEFAULT_CONTRACTOR_IDENTITY_VERIFICATION,
  DEFAULT_CONTRACTOR_PERSONAL_DETAILS,
  DEFAULT_DOCUMENT_DOWNLOAD_RESPONSE,
  DEFAULT_DOCUMENT_URL_RESPONSE,
  GET_CONTRACTORS_COSTS_RESPONSE,
  GET_CONTRACTORS_RESPONSE,
  GET_COUNTRIES_RESPONSE,
} from './fixtures';

export const contractorsHandlers = [
  http.get(`*${COSTS_API_PATH}`, () =>
    HttpResponse.json(GET_CONTRACTORS_COSTS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${COUNTRIES_API_PATH}`, () =>
    HttpResponse.json(GET_COUNTRIES_RESPONSE, { status: HTTPStatusCodes.OK }),
  ),
  http.get(`*${API_PATH}`, () =>
    HttpResponse.json(GET_CONTRACTORS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id`, ({ params }) => {
    return HttpResponse.json(
      GET_CONTRACTORS_RESPONSE.items.find(
        (contractor) => contractor.id === params.id,
      ) || DEFAULT_CONTRACTOR,
      { status: HTTPStatusCodes.OK },
    );
  }),
  http.get(`*${API_PATH}/:id/personal`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_PERSONAL_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.put(`*${API_PATH}/:id/personal`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_PERSONAL_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id/bank-details`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_BANK_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.put(`*${API_PATH}/:id/bank-details`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_BANK_DETAILS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id/kyc`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_IDENTITY_VERIFICATION, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.put(`*${API_PATH}/:id/kyc`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_IDENTITY_VERIFICATION, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id/allowed-kyc-entities`, () =>
    HttpResponse.json(DEFAULT_ALLOWED_ENTITIES_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get('*/documents/:id/download?type=*&disposition=*', () =>
    HttpResponse.json(DEFAULT_DOCUMENT_DOWNLOAD_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get('*/documents/upload-url', ({ request }) => {
    const url = new URL(request.url);
    const filename = url.searchParams.get('filename');
    if (filename) {
      return HttpResponse.json(DEFAULT_DOCUMENT_URL_RESPONSE, {
        status: HTTPStatusCodes.OK,
      });
    }
    // eslint-disable-next-line consistent-return
    return;
  }),
  http.post(`*${DEFAULT_DOCUMENT_URL_RESPONSE.url}`, () =>
    HttpResponse.json(DEFAULT_CONTRACTOR_DOCUMENT_UPLOAD_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*${API_PATH}/:contractorId/contracts/:contractId/deactivate`, () =>
    HttpResponse.json(
      {},
      {
        status: HTTPStatusCodes.OK,
      },
    ),
  ),
  http.get(
    `*${API_PATH}/:contractorId/contracts/:contractId/outstanding-fees`,
    () =>
      HttpResponse.json(DEFAULT_CONTRACT_OUSTANDING_FEES, {
        status: HTTPStatusCodes.OK,
      }),
  ),
  http.put(`*${API_PATH}/:contractorId/contracts/:contractId`, () =>
    HttpResponse.json(DEFAULT_CONTRACT_UPDATE_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
];
